import { useTranslation } from "react-i18next"
import { useState, useRef } from "react"
import { Sector } from "../../logic/btwtool/btwtoolenums"
import { RadioInput } from "../../components/RadioInput"

export function SectorPage({ setState }: { setState: (arg0: Sector) => void }) {
    const { t } = useTranslation(["btwtool", "common"])
    const refs = useRef<(HTMLSpanElement | null)[]>([]);

    const [data, setData] = useState<Sector>()

    const handleRadio = (event: React.ChangeEvent<HTMLInputElement>) => {
        setData(+event.target.value)
    }

    function handleButton() {
        if (data !== undefined) {
            setState(data)
        }
    }

    const master: any = [
        {
            label: t("sector.label.medical"),
            id: "medical",
            name: "activity",
            value: Sector.Medical,
        },
        {
            label: t("sector.label.liberal"),
            id: "liberalProfession",
            name: "activity",
            value: Sector.LiberalProfession,
        },
        {
            label: t("sector.label.education"),
            id: "education",
            name: "activity",
            value: Sector.Education,
        }, {
            label: t("sector.label.insurance"),
            id: "insurance",
            name: "activity",
            value: Sector.Insurance,
        },
        {
            label: t("sector.label.horeca"),
            id: "horeca",
            name: "activity",
            value: Sector.Horeca,
        },
        {
            label: t("sector.label.construction"),
            id: "construction",
            name: "activity",
            value: Sector.Construction,
        },
        {
            label: t("sector.label.waste"),
            id: "waste",
            name: "activity",
            value: Sector.Waste,
        },
        {
            label: t("sector.label.consulting"),
            id: "consulting",
            name: "activity",
            value: Sector.Consulting,
        },
        {
            label: t("sector.label.retail"),
            id: "retail",
            name: "activity",
            value: Sector.Retail,
        },
        {
            label: t("sector.label.other"), // TODO: Tekstveldje om in mixpanel te zien wat de mensen willen als ze op andere klikken
            id: "other",
            name: "activity",
            value: Sector.Other,
        }
    ]

    return (
        <div>
            <h2>{t("sector.title")}</h2>

            <div className="wrapper-col">
                {
                    master.map((el: any, index: any) => {
                        return (
                            <RadioInput
                                label={el.label}
                                id={el.id}
                                name={el.name}
                                index={index}
                                value={el.value}
                                refs={refs}
                                handler={handleRadio}
                            />
                        )
                    })
                }
            </div>

            <button onClick={handleButton} className="button-primary">{t("button__next", { ns: "common" })}</button>
        </div>
    )
}